import {Component, OnInit, Input} from '@angular/core'
import {AngularFirestore} from 'angularfire2/firestore'
import {AngularFireAuth} from 'angularfire2/auth'
import * as firebase from 'firebase'

const MESSAGECOLLECTION = 'messages'
const CREATIVECOLLECTION = 'creatives'
const STATUS = {
  INTERNAL_REVIEW_READY: 'Needs internal review',
  CLIENT_REVIEW_READY: 'Ready for client review',
  REVISION_REQUESTED: 'Revisions requested',
  APPROVED: 'Approved',
  KILLED: 'Killed',
}

@Component({
  selector: 'app-comments',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
  @Input() creative
  newMessage = ''
  messages = []
  STATUS = STATUS

  constructor(private auth: AngularFireAuth, private firestore: AngularFirestore) {}

  ngOnInit() {
    this.getMessages()
    //
    //     this.firestore
    //       .collection(CREATIVECOLLECTION)
    //       .snapshotChanges()
    //       .subscribe(doc => {
    //         doc.map(a => {
    //           a.payload.doc.ref.update({
    //             status: 'INTERNAL_REVIEW_READY',
    //           })
    //         })
    //         // console.log(doc.ref)
    //         // creative.ref.update({
    //         //   status: 'INTERNAL_REVIEW_READY',
    //         // })
    //       })

    // custom dropdown w3schools javascript 
  }

  onKeyPress(event) {
    event.stopPropagation()
  }

  sendMessage(event) {
    // console.log(this.newMessage.trim().length)
    if(this.newMessage.trim().length <= 1) return;

    const message = {
      content: this.newMessage,
      creativeId: this.creative.id,
      projectId: this.creative.projectId,
      author: {
        uid: this.auth.auth.currentUser.uid,
        email: this.auth.auth.currentUser.email,
        displayName: this.auth.auth.currentUser.displayName,
        photoURL: this.auth.auth.currentUser.photoURL,
      },
      date: firebase.firestore.FieldValue.serverTimestamp(),
    }

    this.firestore
      .collection(MESSAGECOLLECTION)
      .add(message)
      .then(() => {
        this.newMessage = ''
      })

    // reset the height of growing textarea
    const growers = Array.from(document.querySelectorAll(".grow-wrap")); 
    growers.forEach((grower) => {
      grower['dataset'].replicatedValue = ' ';
    });
  }

  getMessages() {
    console.log('creativeId', '==', this.creative.id)
    this.firestore
      .collection(MESSAGECOLLECTION, ref => ref.where('creativeId', '==', this.creative.id).orderBy('date', 'desc'))
      .valueChanges()
      .subscribe(messages => {
        console.log('now', messages)
        this.messages = messages
      })
  }

  changeStatus(event) {
    this.firestore.doc([CREATIVECOLLECTION, this.creative.id].join('/')).update({
      status: event.target.value,
    })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/chat/chat.component.ts